import { render, staticRenderFns } from "./MetadadosCampoDinamicoMultiplaEscolha.vue?vue&type=template&id=281a2044"
import script from "./MetadadosCampoDinamicoMultiplaEscolha.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoMultiplaEscolha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports